// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '@/app/store/session';
// Components
import Dropdown from '@/common-utils/components/renders/dropdown/Dropdown';
// Common
import ICONS from '@/common-utils/enums/icons';
import Permissions from '@/app/permissions/Permissions';
// Lang
import { nsRemoteCollection } from '@/app/i18n/namespaces';
import actionsRemoteCollections from '@/app/modules/remoteCollections/api/actionsRemoteCollections';
import transactionsFields from '@/app/modules/remoteCollections/fields/transactionsFields';
import { useToast } from '@/common-utils/hooks/use-toast';
import { findApplicationFromCode } from '@/app/modules/contracts/enums/ItpRegex';
import ModalSendTransactionByMail from '../modals/ModalSendTransactionByMail';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
/**
 * @param root0
 * @param root0.setLaunchRefetch
 * @param root0.transaction
 * @returns {JSX}
 */
function DropdownTransactionsActionsRow({ transaction, setLaunchRefetch }) {
    // Store
    const permissions = useSessionStore(s => s.session.permissions);

    // State
    const [showModalSendMailTransaction, setShowModalSendMailTransaction] = useState(false);

    // Toast
    const { toast } = useToast();

    // API Calls
    const submitRefreshAlmaTransactions = actionsRemoteCollections.refreshAlmaTransactions(() => { }, () => { });

    // Functions
    const shouldShowSendMail = () => {
        const applications = transaction ? transaction[transactionsFields.APPLICATION.key] : false;
        const actionsMailToDisplay = applications ? findApplicationFromCode(applications) : false;
        return actionsMailToDisplay && actionsMailToDisplay.mail;
    };
    const shouldShowManualUpdate = () => {
        const applications = transaction ? transaction[transactionsFields.APPLICATION.key] : false;
        const actionsUpdateToDisplay = applications ? findApplicationFromCode(applications) : false;
        return actionsUpdateToDisplay && actionsUpdateToDisplay.manualUpdate;
    };
    const refreshTransactionAlma = async () => {
        toast({
            description: <Entity entity='toast.refresh.loading' namespace={nsRemoteCollection} />,
            variant: 'default'
        });

        const reconciliationNumber = transaction[transactionsFields.RECONCILIATION_NUMBER.key];
        const contractNumber = transaction[transactionsFields.CONTRACT.key];
        const application = transaction[transactionsFields.APPLICATION.key];
        try {
            // launch refresh call
            await submitRefreshAlmaTransactions.mutateAsync({
                reconciliationNumber: reconciliationNumber,
                contractNumber: contractNumber,
                application: application
            });
            // handle error from api
            if (submitRefreshAlmaTransactions.isError) {
                return (
                    toast({
                        description: <Entity entity='toast.refresh.error' namespace={nsRemoteCollection} />,
                        variant: 'danger'
                    })
                );
            } else {
                return (
                    setLaunchRefetch(true),
                    toast({
                        description: <Entity entity='toast.refresh.success' namespace={nsRemoteCollection} />,
                        variant: 'success'
                    })
                );
            }
        }
        // eslint-disable-next-line no-unused-vars
        catch (error) {
            setLaunchRefetch(true);
            return (
                toast({
                    description: <Entity entity='toast.refresh.error' namespace={nsRemoteCollection} />,
                    variant: 'danger'
                })
            );
        }
    };

    return (
        <>
            <Dropdown
                triggerValues={{ variant: 'ghostNoBorder', icon: ICONS.MORE }}
                actions={[
                    {
                        icon: ICONS.CONTACT_MAIL,
                        entity: 'actions.row.send_by_mail',
                        namespace: nsRemoteCollection,
                        onClick: () => setShowModalSendMailTransaction(true),
                        visible: shouldShowSendMail(),
                        disabled: !hasRequiredPermissions({
                            permissions: permissions,
                            requiredPermissions: [Permissions.PAYMENT_SEND_REMOTE_COLLECTION_NOTIFICATION.name]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    },
                    {
                        icon: ICONS.REFRESH,
                        entity: 'actions.row.refresh_transaction',
                        namespace: nsRemoteCollection,
                        className: 'text-warning',
                        onClick: () => refreshTransactionAlma(),
                        visible: shouldShowManualUpdate()
                    }
                ]}
            />
            {
                showModalSendMailTransaction &&
                <ModalSendTransactionByMail
                    isOpen={showModalSendMailTransaction}
                    setIsOpen={setShowModalSendMailTransaction}
                    transaction={transaction}
                />
            }
        </>
    );
}
DropdownTransactionsActionsRow.propTypes = {
    transaction: PropTypes.object.isRequired,
    setLaunchRefetch: PropTypes.func.isRequired
};
export default DropdownTransactionsActionsRow;